import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography } from "antd";
import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";
import DonutChart from "./DonutChart";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import { calculateDateRangeFromDate } from "../../Utils/DateConverstion";

const { Title } = Typography;

const pieColors = ["#5470C6", "#91CC75", "#FAC858", "#EE6666"];
const sourceLabels = ["EB", "Wind", "IEX", "Solar"];

const getDonutOption = (title) => ({
  title: {
    text: title,
    left: "center",
    top: 0,
    textStyle: {
      fontSize: 14,
      fontWeight: 600,
    },
  },
  tooltip: {
    trigger: "item",
  },
  legend: {
    bottom: 0,
    left: "center",
  },
  series: [
    {
      name: title,
      type: "pie",
      radius: ["50%", "70%"],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 8,
        borderColor: "#fff",
        borderWidth: 2,
      },
      label: {
        show: false,
      },
      emphasis: {
        label: {
          show: true,
          fontSize: "14",
          fontWeight: "bold",
        },
      },
      labelLine: {
        show: false,
      },
      data: [
        { value: 40, name: "EB" },
        { value: 25, name: "Wind" },
        { value: 20, name: "IEX" },
        { value: 15, name: "Solar" },
      ],
    },
  ],
  color: pieColors,
});

const EnergyDashboard = ({activeTab}) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const { makeRequest } = useStoreUpdaterWithAPI();

  const [donutData, setDonutData] = useState(null);
  const [meters, setMeters] = useState([]);
  const [costings, setCostings] = useState();
  const [inputData, setInputData] = useState({});
  const [refetch,setRefetch]= useState(false)
  const [yesterdayConsumption, setYesterdayConsumption] = useState([
    "C1",
    "C2",
    "C3",
    "C4",
  ]);
  const [mtdConsumption, setMtdConsumption] = useState([
    "C1",
    "C2",
    "C3",
    "C4",
  ]);
  const [renewable, setRenewable] = useState([]);
    useEffect(() => {


    // Call every 1 minute (60000 ms)
    const intervalId = setInterval(setRefetch(!refetch), 60000);

    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, [activeTab]);
  const setChartInputData = () => {
    // setOpen(false);
    const selectedMeterId = localStorage.getItem("dashboardSelectedMeter");
    //console.log(selectedMeterId);

    const currentDate = new Date();
    // //console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    // //console.log(from, to);

    const inputData = {
      meterAutoID: Number(selectedMeterId) || 1,
      FromDate: from,
      ToDate: to,
    };
    setInputData(inputData)
    // //console.log(inputData);
   getDashboardResponse(inputData)
   getDonutData(inputData)
   getRenewableData(inputData)
   getYesterdaySlotData(inputData)
  //  getmtdSlotData(inputData)
  };
  const getDashboardResponse = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_ENERGY_CONSUMPTION}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setDonutData(res);
      }
    });
  };
  const getDonutData = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_ENERGY_CONSUMPTION}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

      //  donut costing
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_DASHBOARD_DONUT_COSTING}?MeterAutoID=${inputData.meterAutoID}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setCostings(res);
      }
    });
  };
  const getRenewableData = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_ENERGY_CONSUMPTION}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

       //  renewable consumption
    const selectedMeterId = localStorage.getItem("dashboardSelectedMeter");
    //console.log(selectedMeterId);
    if (selectedMeterId) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_RENEWABLE_CONSUMPTION}?MeterAutoId=${selectedMeterId}`,
      }).then((res) => {
        //console.log(res);
        if (res) {
          setRenewable(res);
        }
      });
    }
  };
  const getYesterdaySlotData = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_ENERGY_CONSUMPTION}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

       //  renewable consumption
       // yesterday slot
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_YESTERDAY_SLOT_CONSUMPTION}`,
    }).then((res) => {
      //console.log(res);
      if (res) {
        setYesterdayConsumption(res);
      }
    });
  };
  const getmtdSlotData = (inputData) => {
    //console.log(inputData);
    const url = `${APIConstants.ELECTRICAL_DASHBOARD_ENERGY_CONSUMPTION}?MeterAutoID=${inputData.meterAutoID}`;
    //console.log(url);

       // mtd slot
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_MTD_SLOT_CONSUMPTION}`,
    }).then((res) => {
      //console.log(res.length);
      if (res && res.length > 0) {
        //console.log(res.length);
        setMtdConsumption(res);
      }
    });
  };
  useEffect(() => {
    if(activeTab==2){
      setChartInputData();

    }
  }, [activeTab]);
useEffect(() => {
  if ( yesterdayConsumption && inputData) {
    const timer = setTimeout(() => {
      getmtdSlotData(inputData);
    }, 2000);

    return () => clearTimeout(timer); 
  }
}, [yesterdayConsumption, inputData]);

  // useEffect(() => {
   
  
  //   // yesterday slot
  //   makeRequest({
  //     type: APIConstants.GET,
  //     url: `${APIConstants.ELECTRICAL_YESTERDAY_SLOT_CONSUMPTION}`,
  //   }).then((res) => {
  //     //console.log(res);
  //     if (res) {
  //       setYesterdayConsumption(res);
  //     }
  //   });
  //   // mtd slot
  //   makeRequest({
  //     type: APIConstants.GET,
  //     url: `${APIConstants.ELECTRICAL_MTD_SLOT_CONSUMPTION}`,
  //   }).then((res) => {
  //     //console.log(res.length);
  //     if (res && res.length > 0) {
  //       //console.log(res.length);
  //       setMtdConsumption(res);
  //     }
  //   });
  // }, [refetch]);
  //console.log(yesterdayConsumption);
  //console.log(renewable);
  //console.log(mtdConsumption);

  return (
    <div className="p-4 w-full overflow-x-hidden ">
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Card
            bordered
            className={`${isdarkMode?"bg-transparent":"bg-blue-50"} customCard shadow-xl `}
            style={{ borderRadius: 12 }}
            title={
              <span className={`${isdarkMode ? "text-white" : "text-black"} `}>
                {"Consumption By Source (Yesterday)"}
              </span>
            }
          >
            <DonutChart
              title={"Consumption By Source (Yesterday)"}
              day={true}
              report={donutData}
            />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            bordered
            className={`${isdarkMode?"bg-transparent":"bg-blue-50"}  customCard shadow-xl`}
            style={{ borderRadius: 12 }}
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                {"Consumption By Source (MTD)"}
              </span>
            }
          >
            <DonutChart
              title={"Consumption By Source (MTD)"}
              day={false}
              report={donutData}
            />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            bordered
            className={`${isdarkMode?"bg-transparent":"bg-blue-50"}  customCard shadow-xl`}
            style={{ borderRadius: 12 }}
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                {"Costing By Source (Yesterday)"}
              </span>
            }
          >
            <DonutChart
              title={"Costing By Source (Yesterday)"}
              day={true}
              report={costings}
            />
          </Card>
        </Col>
      </Row>

      <div className="mt-4 flex flex-wrap justify-between  items-center">
        {/* Renewables */}
        <div className=" w-[32%] ">
          <Card
            className={`${isdarkMode?"bg-transparent":"bg-blue-50"}  customCard shadow-lg `}
            bordered
            style={{ borderRadius: 12 }}
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Renewables
              </span>
            }
          >
            <Card
              className={`${isdarkMode? "bg-transparent":"bg-blue-50"} mb-3 w-full flex justify-center items-center  shadow-lg`}
              bordered
              hoverable
              style={{ borderRadius: 8 }}
            >
              <Title level={5}  style={{ color: isdarkMode ? "white" : "black" }}>
                Today:
              </Title>
              <p
                className="text-center"
                style={{ marginBottom: 0, color: "#1890ff" }}
              >
                {renewable[0]?.dayRenewable || 0}%
              </p>
            </Card>
            <Card
              className={`${isdarkMode? "bg-transparent":"bg-blue-50"} mb-3 w-full flex justify-center items-center shadow-lg`}
              bordered
              hoverable
              style={{ borderRadius: 8 }}
            >
              <Title level={5} style={{ color: isdarkMode ? "white" : "black" }}>
                Month (To Date):
              </Title>
              <p className="text-center" style={{ color: "#1890ff" }}>
                {renewable[0]?.mtdRenewable || 0}%
              </p>
            </Card>
          </Card>
        </div>

        <div className="flex flex-col w-2/3 h-full">
          {/* Yesterday Consumption */}

          <Card bordered style={{ borderRadius: 12 }}  className={`${isdarkMode? "bg-transparent":"bg-blue-50"}  customCard shadow-xl `} >
            <Title style={{ color: isdarkMode ? "white" : "black" }} level={5}>Yesterday Consumption</Title>
            <div className="flex justify-between overflow-x-scroll gap-3 h-[100px]">
              {yesterdayConsumption.map((c) => (
                <Card
                hoverable
                  className="mx-3 min-w-44 bg-blue-50 mb-3 shadow-lg "
                  bordered
                  style={{ borderRadius: 8 }}
                >
                  <p style={{ marginBottom: 0 }}>{c.slotName}</p>
                  <p level={5} style={{ margin: 0, color: "#1890ff" }}>
                    {c.groupConsumption || 0}
                  </p>
                </Card>
              ))}
            </div>
            <div className="mt-4" style={{ borderRadius: 12 }}>
              <Title style={{ color: isdarkMode ? "white" : "black" }} level={5}>MTD Consumption</Title>
              <div className="flex justify-between  gap-3 overflow-x-scroll">
                {mtdConsumption.map((c) => (
                  <Card
                    className="mx-3 min-w-44 bg-blue-50  mb-3 shadow-lg"
                    bordered
                    hoverable
                    style={{ borderRadius: 8 }}
                  >
                    <p style={{ marginBottom: 0 }}>{c.slotName}</p>
                    <Title level={5} style={{ margin: 0, color: "#1890ff" }}>
                      {c.totalGroupConsumption || 0}
                    </Title>
                  </Card>
                ))}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default EnergyDashboard;
